export const environment = {
    "production":true,
    "baseUrl":"https://aiq-acs-webapi-us-be-aiq-dev-c4ezg3bjbvaeajbz.centralus-01.azurewebsites.net/",
  "uiVersion":"3.0.1",
    "hosturl":"https://aiq-acs-webapi-us-be-aiq-dev-c4ezg3bjbvaeajbz.centralus-01.azurewebsites.net/",
    "ADP_PayrollReport": "b8ae8913-fa1d-4813-93bf-6e21c99010f7",
    "AgingDateReportId": "e1ec6410-5202-471b-b666-170db4c82ecd",
    "AgingReportwithDateReportId": "39793d4d-d000-488f-b820-07a5b73d8654",
    "AgingReportwithoutDateReportId": "3ff88e7b-0ed9-4f5a-b07f-5afb82cc7796",
    "BatchCreateReportId": "611dd2bc-80d5-4340-b828-bb37f2ab0680",
    "BatchViewReportId": "3afef326-fd29-4018-8b36-691647c23cab",
    "BilledClientReportId": "64c7a14b-c7d2-4a61-83d3-ac478f49f3a3",
    "CheckEFT": "e6f0537e-ce54-4f35-9114-edf42167e183",
    "ClaimVsPaid": "e0f9d425-1061-4279-b8c7-35b1e9ae9293",
    "ClientBirthDayReportId": "881711ac-c3d1-41af-8108-054fe3e9ace0",
    "ClientHoursSummaryReportId": "672242b2-9cba-4d73-a004-b7869c84690d",
    "ClientLabels": "61520fb5-358a-4eef-adef-897ec9ecf19b",
    "Client_EmployeeNotesId": "80bb058f-22ac-44f1-8f2d-e4dcad150bab",
    "ComingDueAuthorizationChartReportId": "f0655d6e-2fc7-4cdf-b49d-30738d1aa25d",
    "ComingDueAuthorizationReportId": "2d0c42dc-1e09-46ac-9ecb-8f54b0989433",
    "EmployeeBirthDayReportId": "99619718-965f-4f03-8de8-fc21e4d23c2f",
    "EmployeeHoursSummaryReportId": "f50cbd20-34ae-4d7c-a484-2a2e2c540505",
    "EmployeePayRateReportId": "23fbfe90-7024-4779-8c83-25ddb65160c2",
    "EmployeePayorIdListReportId": "6f3d1ec1-27d0-4245-84b9-a2af1b1c15b5",
    "EndOfYearReport": "eb02b32c-9df1-47d9-a330-718d2c597166",
    "HousingCaseReportId": "4b05b418-786e-4774-8da2-5b05bf5127b2",
    "HousingTimesheetReportId": "85dc5b4f-042b-481a-acf8-1c049deba73c",
    "LastDateofServiceReportId": "532ece87-7f54-4919-ab4a-1df96af2ff40",
    "LiveInReportId": "d8f908f2-8ef6-4cc3-9bfb-b3c6fb0a2aec",
    "MissingTimesheetReportId": "ea4390d1-1a35-4af7-98d7-e5550dbf12ee",
    "OpenInvoiceReportId": "803a80d8-b721-440e-9aec-6d59c2f8e585",
    "PaidPayrollNotBilledReportDetails": "93af448c-16f0-4bb0-a120-401faf33d5c8",
    "PaidPayrollNotBilledReportSummary": "15148a50-cc65-45f5-81fb-335a27ee7c89",
    "PayrollExcelReportId": "dc7d1dc2-b8ec-4ad9-b0f3-950faff20f25",
    "PayrollReportId": "6354fa89-c6f7-4463-bddb-42f1525c3dd9",
    "PowerBIWorkSpace": "cf6bbfd4-909d-4c5f-bfa4-7a510fca4201",
    "PrivatePayMileageLogReportId": "9c1e1e63-7d7c-46d2-a55c-379e10b10fbd",
    "QpEmployeeReportId": "916266da-3cf3-41b2-9901-f01cd1e26a82",
    "QpInfoReportId": "56dd4cee-f593-4d93-9498-5bcd477c8ed7",
    "RPReportId": "9f815469-7bd7-43a9-906f-ed216f92ba48",
    "SpendDown": "c3c53c5f-44b5-4481-a330-cf2d7845162b",
    "SubmissionReportId": "b71011f5-d059-4761-9b7b-66c7606e67b3",
    "SupervisionReportId": "dd714bf6-e9a9-40b3-a994-db52be66b0ab",
    "TimesheetReportId": "7687e82b-373a-4735-93aa-d5e7290c4e79",
    "VisitReportId": "9d7a5c83-b235-4969-84a6-b8d05cd90f9b",
    "WorkHoursSummaryReportId": "cb7bbc95-469f-4c9e-ab0e-6aedd1c42877",
    "clienthoursReportID": "672242b2-9cba-4d73-a004-b7869c84690d",
    "employeeLabels": "0cc95b40-7436-4ab3-ad14-0e585526cdce",
    "inactiveclientReportID": "a370e155-1e16-4274-9172-793b438210b6",
    "EmployeementServiceTimesheetReportId": "c7249ff0-70ba-421e-b5ea-e20717c91903",
    "EmployeementServiceReportId": "4a035b69-1e28-4a00-9027-ea10594ee5e3",
    "revenue": "67b40c2c-b22d-4809-a66e-3f41915bf0d9",
    "EWEReportId": "35046e6f-f5f5-4927-ac07-d34307a55216",
    "Paylocity_PayrollReportId":"6f901e97-cf0c-4b16-aa3c-9661d5da7293",
    "DepositReportId":"54d3de10-f698-4efb-888b-2a659218d1f7",
    "PaymentsByPayerReportId":"cb5b6fe9-a63f-447e-9ab5-93ec02eda36a",
    "DetailedRevenueClaimsReportId":"6d6deacc-915c-4ae3-a84e-8e3536d2fce9",
    "DetailedRevenueTimesheetReportId":"8fef21ce-1e50-4524-91a1-08a86a731de6",
    "MonthEndData_byDate_ReportId":"784fb3e6-8074-4f10-93a7-4c8fdfb094b5",
    "MonthEndData_byMonth_ReportId":"a9c10d47-c48d-4474-9d59-770da55fd370",
    "MonthEndReportId":"4b022e47-fe6e-442f-93cf-f7fdb4a40424",
    "DetailedRevenueMonthEnd":"a0a23bd6-6fda-48b1-8533-f4d9fc203d8f",
    "APMServerURL": 'https://apmrum.allcaresoftware.com',
       "googleApiKey":"AIzaSyAOJA0XHRtR49T4Y4WNzEZXUouGoe9-XlI",
    "environment":"dev",
    }
  